import { Injectable } from "@angular/core";
import { IUI_Settings, IUI_SettingStorage, UI_SETTING_STORAGE, UISettingsStoreConfig } from "../models/index.db..model";
import { from, map, Observable, of, Subject, switchMap, take, tap } from "rxjs";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { setIndexDBversion } from "../app.module";

@Injectable({
  providedIn:'root'
})

export class UIsettingsService {
  public uiSettingsChanged:Subject<IUI_Settings> = new Subject()
  constructor (
    private dbService:NgxIndexedDBService
  ){}
  public uiUserSettings:IUI_Settings|undefined = undefined
  public getUISettings(userGuid:string):Observable<IUI_Settings> {
    let uiItemId:string = userGuid
    return this.dbService.getAllObjectStoreNames()
    .pipe(
        take(1),
        switchMap(stores => stores.includes(UI_SETTING_STORAGE) ? of(true) : this.createSettingStore()),
        //switchMap(stores => stores.includes(UI_SETTING_STORAGE) ? of(true) : of(true)),
        switchMap(() => this.dbService.getByID(UI_SETTING_STORAGE, uiItemId)),
        map(res=>(res as unknown as IUI_SettingStorage)?.settings),
        tap(res=>this.uiUserSettings = res),
    )
  }
  public setUISettings(userGuid:string,settingsValue:IUI_Settings) {
    let uiItemId:string = userGuid
    return this.dbService.update(UI_SETTING_STORAGE,{
      ui_item_id:uiItemId,
      settings:settingsValue
      }
    ).pipe(tap(res=>this.uiSettingsChanged.next(res.settings)))
  }
  createSettingStore(): Observable<boolean> {
      return this.dbService.getDatabaseVersion().pipe(
          tap(indexDBVersion => setIndexDBversion(+indexDBVersion)),
          switchMap(() => from(this.dbService.createObjectStore(UISettingsStoreConfig))),
          map(() => true)
      )
  }
}
